import { Html } from "@react-three/drei";
import { PulseLoader } from "react-spinners";

export default function Loading() {
    return (
        <Html center>
            <div id="loading">
                <p>Cargando modelo...</p>
                <PulseLoader color="#505050" margin={6} size={12} speedMultiplier={0.5} />
            </div>
        </Html>
    );
}
